import React, { memo } from "react";
import PropTypes from "prop-types";

const DisplaySwitchBar = memo(({ setDisplayOrders, setDisplayDetails, setDisplayDealer, setDisplayVehicles }) => {
	return (
		<div className="row">
			<div className="col-xs-12">
				<button className="btn margin-top-12 button-spacing-left-10 pull-right" onClick={setDisplayDetails}>
					<span className="glyphicon glyphicon-user padding-right-5px" aria-hidden="true" />
					Details
				</button>
				<button className="btn margin-top-12 button-spacing-left-10 pull-right" onClick={setDisplayVehicles}>
					<span className="glyphicon glyphicon-road padding-right-5px" aria-hidden="true" />
					Vehicles
				</button>
				<button className="btn margin-top-12 button-spacing-left-10 pull-right"onClick={setDisplayDealer}>
					<span className="glyphicon glyphicon-wrench padding-right-5px" aria-hidden="true" />
					Preferred dealer
				</button>
				<button className="btn margin-top-12 pull-right" onClick={setDisplayOrders}>
					<span className="glyphicon glyphicon-shopping-cart padding-right-5px" aria-hidden="true" />
					VOT orders
				</button>
			</div>
		</div>
	);
});
DisplaySwitchBar.displayName = `DisplaySwitchBar`;
DisplaySwitchBar.propTypes = {
	setDisplayOrders: PropTypes.func,
	setDisplayDetails: PropTypes.func,
	setDisplayDealer: PropTypes.func,
	setDisplayVehicles: PropTypes.func
};

export default DisplaySwitchBar;
